import { render, staticRenderFns } from "./ImageUploadModal.vue?vue&type=template&id=b264b946&"
import script from "./ImageUploadModal.vue?vue&type=script&lang=js&"
export * from "./ImageUploadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports